import React from "react";
import { localize } from "@backpacker/number";
import { shorten } from "@backpacker/number";
import { getMetricLabel } from "@linkfluence/i18n";
import { Locale } from "@linkfluence/models/locale";
import { Metric } from "@linkfluence/models/metric";
import { percent } from "@tootools/number";
import { tr } from "@radarly/i18n";
import { ComparisonPeriod } from "@radarly/models/cards/period";
import { MainUnit, SecondaryUnit, Unit } from "@radarly/models/data-units";

type EvolutionLabelProps = {
  locale: Locale;
  mainUnit: MainUnit;
  comparisonPeriod: ComparisonPeriod;
  evolution?: number;
};

type HorizontalBarChartFooterProps = {
  locale: Locale;
  mainUnit: MainUnit;
  comparisonPeriod: ComparisonPeriod;
  evolution?: number;
  secondaryUnit: SecondaryUnit;
  count: number;
  total: number;
  isHideable?: boolean;
  isHidden?: boolean;
};

export const getContent = (
  locale: Locale,
  count: number,
  total: number,
  metric: Metric,
  isNormalized: boolean = false
) => {
  const content = `${localize(locale, count)} ${getMetricLabel(
    locale,
    metric
  )}`;
  return isNormalized && total
    ? `${shorten(locale, percent(count, total), 3, false, 1)}% - ${content}`
    : content;
};

export const getEvolutionLabel = ({
  locale,
  mainUnit,
  comparisonPeriod,
  evolution = 0,
}: EvolutionLabelProps) => {
  if (isNaN(evolution) || evolution === null || !comparisonPeriod) {
    return null;
  }
  const shortEvolution = shorten(locale, evolution, 3, true);
  if (mainUnit === Unit.total) {
    return comparisonPeriod === "last_year"
      ? tr(locale, "TOOLTIP::EVOLUTION::PREVIOUS_YEAR", {
          percentage: shortEvolution,
        })
      : tr(locale, "TOOLTIP::EVOLUTION::PREVIOUS_PERIOD", {
          percentage: shortEvolution,
        });
  }
  if (mainUnit === Unit.percentage) {
    return comparisonPeriod === "last_year"
      ? tr(locale, "TOOLTIP::EVOLUTION::PREVIOUS_YEAR_PERCENTAGE_POINTS", {
          percentage: shortEvolution,
        })
      : tr(locale, "TOOLTIP::EVOLUTION::PREVIOUS_PERIOD_PERCENTAGE_POINTS", {
          percentage: shortEvolution,
        });
  }
  return null;
};

export const getHorizontalBarChartFooter = (
  props: HorizontalBarChartFooterProps
) => {
  const { locale, count, total, isHidden, isHideable } = props;
  return (
    <div>
      <div>
        {tr(locale, "TOOLTIP_PENETRATION_RATE", {
          rate: shorten(locale, percent(count, total)),
        })}
      </div>
      {getEvolutionLabel(props)}
      {isHideable && (
        <div>
          <p>
            {tr(
              locale,
              `INSIGHT_PAGE::EDITOR::HIDDENT_TERM_CLICK_${
                isHidden ? "SHOW" : "HIDE"
              }`
            )}
          </p>
        </div>
      )}
    </div>
  );
};
